<!-- Admin Edit Article Validate & Update -->

<template>
	<div class="adm-edit-chk">
		<div class="mess-box">

			<div v-for="(mess, idx) in mex" :key="'mex' + idx">
				{{ mess }}
			</div>

			<div v-for="(mess, idx) in erx" :key="'erx' + idx" class="err-mess">
				{{ mess }}
			</div>

		</div>


		<div class="v-spacer"></div>


		<div class="submit-box">
			<div class="ok-lab wi8_font">
				OK:
			</div>

			<div :class="(allOK)? 'chk-box active': 'chk-box'" @click="clickOK">
				<UniIcon 
					ico="check" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>

			<br />
			<div v-if="(allOK)" class="save-btn wi8_font" @click="clickSave">
				Save
			</div>
		</div>


	</div>
</template>

<script>
import * as Utils from "@/utils/utils";
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
import { eventBus } from "@/main";
export default {
	data() {
		return {
			rec: {},
			pix: [],
			mex: [],
			erx: [],
			dateOk: false,
			allOK: false,
		}
	},
	computed: {
		...mapState('app', ['current']),
	},
	methods: {
		clickSave() {
			m("adm edit click savet");
			Utils.blur();
			this.allOK = false;


			let payloadPost = {
				popType: "win",
				popTitle: "Updating Article",
				popText: "",
				compName: "UniPost",
				compData: {
					step: "current",
					autoPost: true,
				},
			};

			let payloadTrx = {
				trx:"clear",
			}

			// Clear trx status then post
			// this.$store.dispatch("app/updTrxStatus", payloadTrx)
			// .then( () => {
				eventBus.$emit("popup", payloadPost);	
			// })


		},


		clickOK() {
			this.ublur();
			this.allOK = !this.allOK;
		},

		// Validate all items
		valAll() {
			this.valCat();
			this.valStory();
			this.valDate();
			this.valPix();

			let mess = this.erx.length + " ";
			mess += (this.erx.length==1)? " issue": " issues";
			this.mex.push(mess);
		},
		
		// Validate Category
		valCat() {
			let line = "Category: art: " + this.rec.catId;
			if (this.rec.cat) {
				line += ", cat: " + this.rec.cat.itemId + ': ' + this.rec.cat.title;
				if (this.rec.cat.pub!='1') {
					this.erx.push('Invalid category');
				}
			} else {
				this.erx.push('Missing category');
			}
			this.mex.push(line);
		},

		// Validate Story
		valStory() {
			let line = 'Article: rid: ' + this.rec.rid;
			line += ', live: ' + ((this.rec.live == '1')? 'yes':'NO');
			line += ', merit: ' + ((this.rec.merit == 'ok')? 'yes':'NO');
			line += ', stage: ' + this.rec.stage;
			this.mex.push(line);

			const tLen = this.rec.title.length;
			const sLen = this.rec.fullTxt.length;

			this.mex.push('Title: ' + tLen + ' chars' + ', Story: ' + sLen + ' chars');

			if (tLen==0) this.erx.push('Missing title');
			if (sLen==0) this.erx.push('Missing story');

		},

		// Validate Date
		valDate() {
			const answer = this.uvaliDateStr(this.rec.dateCre);
			if (answer.ok) {
				this.dateOk = true;
			} else {
				this.dateOk = false;
				this.erx.push('Invalid date will be ignored.');
			}

			this.mex.push("Date: " + answer.date);
		},

		// Validate Pix
		valPix() {
			let mainPixIdx = 0;
			let mainPixId = 'none';
			let pixQtyActive = 0;
			let pixQtyInactive = 0;

			m('val pix: art', this.rec);
			for (let i=0; i<this.pix.length; i++) {
				const rec = this.pix[i];
				m('pix rec', rec);
				if (rec.merit=='ok' && rec.live=='1' && rec.stage=='ok') {
					pixQtyActive ++;
					if (this.rec.pixId == rec.itemId) {
						mainPixIdx = i;
						mainPixId = rec.itemId;
					}
				} else {
					pixQtyInactive ++;
				}
			}

			const s1 = 'Pix total: ' +  this.pix.length +', active: ' +  pixQtyActive + ', inactive: ' + pixQtyInactive;
			this.mex.push(s1);
			this.mex.push('Main pix: #' + mainPixIdx + ' ' + mainPixId);

			if (mainPixId=='none') this.erx.push("No main image selected");


		},
	},
	mounted() {
		m("adm edit upd mounted");
		this.rec = this.current.art;
		this.pix = this.current.pix;
		this.valAll();
	}
}
</script>

<style scoped>

.adm-edit-chk {
	height: 100%;
	overflow: hidden;
	border: solid 0px #C30;
}

.mess-box {
	height: 250px;
	padding: 10px;
	overflow: hidden;
	border-radius: 5px;
	border: solid 1px #999;
}

.submit-box {
	height: 100px;
	padding: 10px;
	overflow: hidden;
	text-align: right;
	border-radius: 5px;
	border: solid 1px #999;
}

.ok-lab {
	display: inline-block;
	width: 60px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px;
	border: solid 0px #999;
}

.save-btn {
	display: inline-block;
	width: 64px;
	height: 32px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px;
	text-align: center;
	color: #369;
	cursor: pointer;
	background-color: #FFF;
	border-radius: 5px;
	border: solid 2px #369;
}


.chk-box {
	display: inline-block;
	width: 30px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	cursor: pointer;
	background-color: #EEE;
	border-radius: 4px;
	border: solid 1px #999;
}

.active {
	background-color: #393;
}

.err-mess {
	color: #C30;
}

.v-spacer {
	width: 10px;
	height: 10px;
	border: solid 0px #000;
}
</style>
